import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";
import { GameiomIdle } from "gameiom/states/gameiom-idle";
import { LayerNames } from "game-layers";

export class ThemeGameiomIdle extends GameiomIdle {

    public onEnter(): void {
        super.onEnter();
        this.displayNonWinningLines();
        this.signalBindings.push(Services.get(SlotBetService).onBetChange.add(() => this.displayNonWinningLines()));
    }

    protected displayNonWinningLines() {
        let lineNo = Services.get(SlotBetService).getSelectedLines();

        for (var i = 0; i < 9; i++) {
            var layer = Layers.get(LayerNames.StepperLineDisplay);
            var line = layer.getSprite("line_" + i + "_deactivated-line" + i + "_segment");
            var dot = layer.getSprite("line_" + i + "_deactivated-line" + i + "_dots");

            if(i >= lineNo) {
                line.hideTexture();
                dot.hideTexture();
            }
            else {
                line.showTexture();
                dot.showTexture();
            }
        }
    }
}